angular.module('impactx.download').service('DownloadService', DownloadService);

DownloadService.$inject = ['NewWindowService', '$config', '$securityManager'];

function DownloadService(NewWindowService, $config, $securityManager) {

    this.openDownloadPost = function(endpoint, param) {
        var form = document.createElement('form');
        form.action = $config.sourceURL + endpoint;
        form.method = 'POST';
        form.target = '_blank';
        form.style.display = 'none';

        var input = document.createElement('input');
        input.type = 'text';
        input.name = 'token';
        input.value = $securityManager.getToken();

        var paramsInput;
        if(param) {
            paramsInput = document.createElement('input');
            paramsInput.name = param.paramName;
            paramsInput.value = (typeof (param.paramValue) === 'string' || param.paramValue instanceof String) ? param.paramValue : angular.toJson(param.paramValue);
        }

        var submit = document.createElement('input');
        submit.type = 'submit';
        submit.id = 'submitForm';

        form.appendChild(input);
        if (paramsInput) {
            form.appendChild(paramsInput);
        }
        form.appendChild(submit);
        document.body.appendChild(form);

        $('#submitForm').click();

        document.body.removeChild(form);
    };

    this.openParamDownloadPost = function(endpoint, params) {
        var form = document.createElement('form');
        form.action = $config.sourceURL + endpoint;
        form.method = 'POST';
        form.target = '_blank';
        form.style.display = 'none';

        var input = document.createElement('input');
        input.type = 'text';
        input.name = 'token';
        input.value = $securityManager.getToken();

        var submit = document.createElement('input');
        submit.type = 'submit';
        submit.id = 'submitForm';

        form.appendChild(input);
        for (var i = 0; i < params.length; i++) {
            var paramsInput = document.createElement('input');
            paramsInput.name = params[i].paramName;
            paramsInput.value = (typeof (params[i].paramValue) === 'string' || params[i].paramValue instanceof String) ? params[i].paramValue : angular.toJson(params[i].paramValue);
            form.appendChild(paramsInput);
        }
        form.appendChild(submit);
        document.body.appendChild(form);

        $('#submitForm').click();

        document.body.removeChild(form);
    };
}